import React from 'react';

import { connect } from "react-redux"//联系store的组件
import evn from "./../../../actions/index"//action的所有事件
import EventJS from "./../../../assets/PubJs/hcPub"//所有事件
import "./CaseDetailsInfo.css"//引入样式
import CaseDetailsInfo from "./CaseDetailsInfo.js"//引入组件
import { Button, Modal } from 'antd';//引入antd组件


let _App = null;
class App extends React.Component {
    state = {
        cid: 0,
        type: '',//页面来源
    };

    //点击确定事件
    handleOk = (e) => {
        this.props.dispatch(evn.hideCaseInfo(this.props.caseId))
    };

    componentWillReceiveProps(e) {
        //this.setState({ cid: e.caseId }, () => {
        //    this.handleData();
        //})
    }

    //点击取消事件
    handleCancel = (e) => {
        this.props.dispatch(evn.hideCaseInfo(this.props.caseId))
    };
    //点击关闭页面
    handleClose = (e) => {
        window.opener = null; window.close();
    };
    //渲染组件
    render() {
        return (
            <div id="caseModalview">
                <div className='cssCloseCase'>
                    <Button type="primary" style={{ marginLeft: '10px' }} onClick={() => this.handleClose()}>关闭页面</Button>
                </div>
                <div className='cssCaseInfo'>
                    <CaseDetailsInfo cid={EventJS.getQueryString('cid')} type={EventJS.getQueryString('fromType')} />
                </div>
               
            </div>
        );
    }
}

export default connect()(App)


// WEBPACK FOOTER //
// ./src/components/Content/Common/CaseDetailsInfoView.js